import type { User } from "@investhinks/api-client";

import { isZeroPriceTier } from "./isZeroPriceTier";

/**
 * Returns true if the user should receive VIP treatment:
 * either the legacy isVIP flag OR being on a zero-price tier.
 *
 * Use this for all behavioral gates (hiding payment errors, showing change
 * payment button) to ensure zero-price tier users are treated identically
 * to legacy VIP users.
 *
 * Note: subscription_tier may not always be populated on the user object.
 * If not populated, this falls back to isVIP only. Zero-price tier users
 * who don't have subscription_tier populated will continue to work because
 * their subscriptions have pm_status="active" (not "failed"/"unpaid").
 *
 * When all users are migrated off isVIP, simply remove the isVIP check here.
 */
export function isVipOrZeroPriceTier(
  user: (Pick<User, "isVIP"> & { subscription_tier?: User["subscription_tier"] }) | null | undefined
): boolean {
  if (!user) return false;
  if (user.isVIP) return true;
  return isZeroPriceTier(user.subscription_tier);
}

export default isVipOrZeroPriceTier;
